import Parallax from 'parallax-js';
import helpers from '../../helpers';

const pause = (parent) => {
	if (!parent) {
		return;
	}

	parent.querySelectorAll('.chapter__decor--figure').forEach((element) => {
		if (element.parallax && element.parallax.enabled) {
			element.parallax.disable();
		}
	});
};

const play = (parent) => {
	const isMobile = helpers.isMobile();
	if (!parent) {
		return;
	}

	if (!isMobile) {
		parent.querySelectorAll('.chapter__decor--figure').forEach((element) => {
			if (element.parallax && !element.parallax.enabled) {
				element.parallax.enable();
			} else if (!element.parallax) {
				element.parallax = new Parallax(element, {
					invertX: false,
					invertY: false,
					scalarX: 40,
				});
			}
		});
	}
};

const figureParallax = (parent) => {
	pause(document.body);
	play(parent);
};

export {figureParallax};
